var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.2122C13.3463 12.2122 14.4377 11.1918 14.4377 9.93306C14.4377 8.6743 13.3463 7.65388 12 7.65388C10.6537 7.65388 9.56228 8.6743 9.56228 9.93306C9.56228 11.1918 10.6537 12.2122 12 12.2122Z",
    fill: "#44494D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8172 12.9763H11.1898C8.94063 12.9763 7.12456 14.6808 7.12456 16.7771V17.1559H16.8894V16.7771C16.8824 14.6808 15.0594 12.9763 12.8172 12.9763Z",
    fill: "#44494D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 17.7698 1.52969 19.2 3.42258 19.2H20.5774C22.4703 19.2 24 17.7698 24 16V6.4C24 4.6302 22.4703 3.2 20.5774 3.2H18.908L17.6438 1.42367C17.0081 0.53551 15.9395 0 14.7939 0H3.42258C1.52969 0 0 1.4302 0 3.2V16ZM8.71013 2.13551L9.31781 2.82122C9.53434 3.06286 9.85565 3.20653 10.1909 3.20653H16.163L15.7439 2.61225C15.5343 2.31837 15.1781 2.13551 14.7939 2.13551H8.71013ZM10.1909 5.33551C9.17811 5.33551 8.2142 4.91102 7.56461 4.18612L6.08382 2.51429C5.86729 2.27265 5.54598 2.12898 5.21071 2.12898H3.42258C2.79395 2.12898 2.28405 2.60571 2.28405 3.19347V15.9935C2.28405 16.5812 2.79395 17.058 3.42258 17.058H20.5774C21.2061 17.058 21.7159 16.5812 21.7159 15.9935V6.4C21.7159 5.81225 21.2061 5.33551 20.5774 5.33551H10.1909Z",
    fill: "#44494D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/IconProfile.9bbbebcc.svg";
export { ForwardRef as ReactComponent };